/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Noise from './Noise';

const { pow } = Math;

export default class NoiseBeat extends Noise {
	drive({ pulse }) {
		return pow(pulse, 20);
	}
}
